export default __webpack_public_path__ + "static/media/pg-28.8c1fad86.jpg";